import * as React from 'react';
import walk from "../../assets/icon/walk.gif";
import running from "../../assets/icon/running.gif";
import running100 from "../../assets/icon/running100.gif";
import runningjump from "../../assets/icon/runningjump.gif";
import rices from "../../assets/icon/rices.gif";
import ricen from "../../assets/icon/ricen.gif";
import ricee from "../../assets/icon/ricee.gif";
import ricese from "../../assets/icon/ricese.gif";
import careStore from "../../store/careStore";
import {useEffect} from "react";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CareRate = () => {
  const storeData: any = careStore();
  
  useEffect(() => {
    
    return () => {
    }
  }, []);
    
  // 선택 항목 클릭 이벤트
  const handleCheckedBoxes = (e :any) => {
    const targetName = e.target.name;
    if(e.target.checked){
      storeData.setCareInfo('food', targetName);
    }else{
      storeData.setCareInfo('food', 0);
    }
  };
 
  

  return (
    <Stack  sx={{ width: '100%', background:'#F1F2F4', minWidth:320}} spacing={2}>

      <Grid sx={{bgcolor:'#fff', p:0, pt:2,pb:0, width:'100%', minHeight:515 }}>
        <Box sx={{ boxSizing: 'border-box',}}>
          <Typography  component="div" sx={{fontSize:18, pb:1, color:'#555', m:4, mb:0, textAlign:'center'}}>
            운동을 통한 감량과 식사를 위한<br /> 감량의 비율은 어땠으면 좋겠나요?
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row', p:1,
              margin:' 0 auto',
              boxSizing: 'border-box',
              justifyContent:'center',
              '& .MuiFormControlLabel-root': {}
            }}
          >
            <FormGroup sx={{p:0, justifyContent:"center"}} aria-label="position" row >
              <Stack flexDirection={'row'} >
                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <AvatarGroup max={2} sx={{justifyContent:'center', m:'10px 0', '& .MuiAvatar-root' : {border:'1px solid #ccc'}}}>
                    <Avatar alt="" src={walk} sx={{ }} />
                    <Avatar alt="" src={ricen} sx={{ }} />
                  </AvatarGroup>
                  <FormControlLabel control={
                    <Checkbox onClick={handleCheckedBoxes} name="19" checked={storeData.careInfo.food === '19' || storeData.careInfo.food === ''}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="운동1:식사9"  
                      labelPlacement="top" 
                    />
                </Box>

                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <AvatarGroup max={2} sx={{justifyContent:'center', m:'10px 0', '& .MuiAvatar-root' : {border:'1px solid #ccc'}}}>
                    <Avatar alt="" src={running} sx={{ }} />
                    <Avatar alt="" src={ricee} sx={{ }} />
                  </AvatarGroup>
                  <FormControlLabel control={
                    <Checkbox onClick={handleCheckedBoxes} name="28" checked={storeData.careInfo.food === '28'}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="운동2:식사8"  
                      labelPlacement="top" 
                    />
                </Box>
              </Stack>

              <Stack flexDirection={'row'} >
                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <AvatarGroup max={2} sx={{justifyContent:'center', m:'10px 0', '& .MuiAvatar-root' : {border:'1px solid #ccc'}}}>
                    <Avatar alt="" src={running100} sx={{ }} />
                    <Avatar alt="" src={ricese} sx={{ }} />
                  </AvatarGroup>
                  <FormControlLabel control={
                    <Checkbox onClick={handleCheckedBoxes} name="37" checked={storeData.careInfo.food === '37'}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="운동3:식사7"  
                      labelPlacement="top" 
                    />
                </Box>

                <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                  <AvatarGroup max={2} sx={{justifyContent:'center', m:'10px 0', '& .MuiAvatar-root' : {border:'1px solid #ccc'}}}>
                    <Avatar alt="" src={runningjump} sx={{ }} />
                    <Avatar alt="" src={rices} sx={{ }} />
                  </AvatarGroup>
                  <FormControlLabel control={
                    <Checkbox onClick={handleCheckedBoxes} name="46" checked={storeData.careInfo.food === '46'}
                      icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                      
                      sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                        color: '#3ecbca',
                      },  }} />} 
                      label="운동4:식사6"  
                      labelPlacement="top" 
                    />
                </Box>
              </Stack>

            </FormGroup>
          </Box>
            
        </Box>
      </Grid>

    </Stack >
  );
}

export default CareRate;